import React from 'react';

import LearnMore from 'components/learnMore';
import HighlightedText from 'components/highlightedText';
import { Title } from 'components/typography';
import { AFEX } from 'config';

import { joinUsTitle, learnMore } from './scss/JoinUs.module.scss';

const JoinUs = () => {
  return (
    <div className={joinUsTitle}>
      <Title
        size="xl"
        value={
          <span>
            {'we are always on the look-out'}
            <br className="d-none d-md-block" />
            {' for the'}
            <HighlightedText value="curious & creative" />
          </span>
        }
      />
      <div>
        <LearnMore
          className={learnMore}
          prefix="THINK YOU ARE?"
          context="JOIN US"
          href={AFEX.SIGNUP_LINK}
          tag="a"
          target="_blank"
          rel="noopener noreferrer"
        />
      </div>
    </div>
  );
};

export default JoinUs;
